import React, { useState, useEffect } from "react";
import "./login/Login.scss";
import { Image } from "primereact/image";
import { Divider } from "primereact/divider";
import LesothoIcon from "../assets/images/ieclogos.png";
import { Button } from "primereact/button";
import { useMsal, UnauthenticatedTemplate } from "@azure/msal-react";
import LoadingModules from "../componets/Azure/LoadingModules";
import { REACT_APP_VERSION } from "../config/Config";

export default function Login() {
	const [loading, setLoading] = useState(false);
	const { instance } = useMsal();

	const login = async () => {
		setLoading(true);
		try {
			const claims = JSON.stringify({
				id_token: {
					deviceid: {
						essential: true
					}
				}
			});

			// Trigger the login process using popup
			await instance.loginPopup({
				scopes: ["User.Read"],
				claims
			});

			setLoading(false);
		} catch (error) {
			console.error("Login failed:", error);
			setLoading(false);
			instance.logoutRedirect().catch((error) => console.log(error));
		}
	};

	return (
		<div>
			<LoadingModules visible={loading} />
			<UnauthenticatedTemplate>
				{/* <Toast ref={(el) => (this.toast = el)} /> */}

				<div className="card-size">
					<div>
						<div className="box p-fluid p-grid">
							<div className="p-field p-col-12 hide-small">
								<Divider layout="vertical" />
							</div>
							<div className="p-field p-col-12">
								<Image src={LesothoIcon} alt="Image" width="300px" />

								<div className="Card">
									<Button
										className="p-button-lg p-mt-5"
										label="Login"
										icon="pi pi-unlock"
										iconPos="right"
										onClick={login}
										loading={loading}
									/>
								</div>
							</div>
						</div>
						
						<div  style={{justifyContent:"center"}} className="w-full flex">
						<b  style={{textAlign:"center"}}  className="w-full">Version - {REACT_APP_VERSION}</b>
						</div>
					</div>
				</div>
			</UnauthenticatedTemplate>
		</div>
	);
}
